import React, { MutableRefObject } from "react"

import classnames from "classnames"

import { useTranslations } from "@cirrus/core/i18n"
import { NumberInput } from "@cirrus/legacy/app-components/entries/lib"
import Icon from "@cirrus/legacy/app-components/icons/icon/index"

import { useStyles } from "./styles"
import { usePaging } from "./usePaging"
import { PdfDialog_SetStateAction, PdfDialogState } from "../state"
import { ViewerApi } from "../viewer/api"

interface IProps {
  state: PdfDialogState;
  setState: PdfDialog_SetStateAction;
  viewerApiRef: MutableRefObject<ViewerApi | undefined>
}

export const Footer = (props: IProps) => {

  const { state, setState, viewerApiRef } = props
  const { i18n } = useTranslations()

  const styles = useStyles()

  const {
    onPageChangeFocus,
    onPageBlurFocus,
    onPageChange
  } = usePaging(state, setState, viewerApiRef)

  return (
    <div className={`pdf-dialog-controls ${styles.controls}`}>
      <div className={styles.section}>
            <span className={styles.pager}>
              {i18n("General:Page")}
              <NumberInput
                dataQa="pdf-input-page"
                type="int"
                className={styles.input}
                forbidNegative
                onFocus={onPageChangeFocus}
                onBlur={onPageBlurFocus}
                notValid={
                  Boolean(state.numPages) &&
                  (state.currentPage < 1 || state.currentPage > state.numPages)
                }
                ariaLabel={i18n("General:Page")}
                value={state.currentPage}
                onChange={onPageChange}
              /> / <span className={styles.pagerNumber}>{state.numPages}</span>
            </span>
      </div>

      <div className={styles.section}>
        <Icon
          icon={"fa-plus"}
          onClick={() => {
            viewerApiRef.current?.zoomUp()
          }}
          className={styles.icon} />
        <Icon
          icon={"icon-expand3"}
          onClick={() => {
            viewerApiRef.current?.fitWidth()
          }}
          className={classnames(styles.icon, styles.fitWidth)} />
        <Icon
          icon={"fa-minus"}
          onClick={() => {
            viewerApiRef.current?.zoomDown()
          }}
          className={classnames(styles.icon)} />
      </div>
    </div>
  )
}
